// extracted by mini-css-extract-plugin
module.exports = {"items":"CartIncludedItems-pepxpress_items__2SeNO","item":"CartIncludedItems-pepxpress_item__mGj2p"};